module.exports = __webpack_public_path__ + "img/051-cayman-islands.a6f3b941.svg";